import React, { useState, useEffect } from 'react'
// import { ResponsiveBar } from '@nivo/bar'
// import { generateCountriesData } from '@nivo/generators'
// import { colors } from '../../constants'
import { Bar, Chart } from 'react-chartjs-2'
// import 'chartjs-plugin-labels'
// Chart.plugins.register({
//     afterDatasetsUpdate: function(chart) {
//       Chart.helpers.each(chart.getDatasetMeta(0).data, function(rectangle, index) {
//         rectangle._view.width = rectangle._model.width = 30;
//       });
//     },
//   })

// var data = {
//     labels: ["x1", "x2", "x3"],
//     datasets: [{
//       label: "First",
//       backgroundColor: 'rgba(255, 99, 132, 0.2)',
//       borderWidth: 1,
//       data: [10, 20, 30],
//       xAxisID: "bar-x-axis1",
//     }, {
//       label: "Second",
//       backgroundColor: 'rgba(255, 206, 86, 0.2)',
//       borderWidth: 1,
//       data: [5, 30, 35],
//       xAxisID: "bar-x-axis1", // will not work if set to 'bar-x-axis2'
//     }]
//   };

Chart.defaults.global.defaultFontFamily = "iransans";
// Chart.defaults.global.defaultFontSize = 18;

var options = {
  tooltips: {
    titleFontFamily: 'iransans',
    bodyFontFamily: 'iransans',
    footerFontFamily: 'iransans',
    yAlign: 'bottom',
    backgroundColor: '#F34255',
    bodyFontColor: '#fff',
    displayColors: false,
  },
  // cornerRadius: 7,
  scales: {
    xAxes: [{
      display: true,
      // gridLines: {
      //   display: false,
      // },

      ticks: {
        fontColor: '#000',
        fontStyle: 'normal',
        fontSize: 13,
        fontFamily: 'iransans'
        // padding: -170,
      },
      // stacked: true,
      id: "bar-x-axis1",
      barThickness: 8,
    }],
    yAxes: [{
      display: true,
      gridLines: {
        display: false,
      },
      stacked: false,
      ticks: {
        display: true,
        fontColor: '#000',
        fontStyle: 'normal',
        fontSize: 13,
        fontFamily: 'iransans',
        beginAtZero: true,
      },
      barThickness: 5,
    }]
  },
  

  responsive: true,
  // legend: {
  //   display: false,
  //   labels: {
  //     fontFamily: 'iransans',
  //     fontColor: '#000'
  //   }
  // },
  // title: {
  //   display: false,
  //   fontColor: '#CC6E6E',
  //   fontStyle: 'normal',
  //   fontSize: 20,
  //   fontFamily: 'iransans',
  //   display: true,
  //   text: 'نمودار میزان تولید ورق پرس شده',
  //   padding: 30
  // },
  // animation: {
  //   // duration: 1,
  //   // easing: 'easeInOutExpo',
  //   onProgress: function () {
  //     var chartInstance = this.chart,
  //       ctx = chartInstance.ctx;
  //     ctx.font = 1.3 + "em iransans";
  //     // ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
  //     ctx.textAlign = 'center';
  //     ctx.textBaseline = 'middle';

  //     this.data.datasets.forEach(function (dataset, i) {

  //       var meta = chartInstance.controller.getDatasetMeta(i);
  //       meta.data.forEach(function (bar, index) {
  //         var data = dataset.data[index];
  //         if (i === 0) {
  //           ctx.fillStyle = '#fff';
  //           ctx.fillText(data, bar._model.x, bar._model.y + 15);

  //         } else {
  //           ctx.fillStyle = '#000';
  //           ctx.fillText(data, bar._model.x, bar._model.y - 10);

  //         }

  //       });
  //     });
  //   }
  // }
  maintainAspectRatio: false,
  // plugins: {
  //   labels: [{
  //     render: 'value',
  //     fontFamily: 'iransans',
  //     fontColor: '#000',
  //     textMargin: 4,
  //     // fontColor: function (args) {
  //     //   // args will be something like:
  //     //   // { index: 0, dataset: {...} }

  //     //   if (args.dataset.label == 'سفر') {
  //     //     return '#000';
  //     //   }
  //     // },
  //     // render: function (args) {
  //     //   // args will be something like:
  //     //   // { label: 'Label', value: 123, percentage: 50, index: 0, dataset: {...} }

  //     //   if (args.dataset.label == 'سفر') {
  //     //     if (args.value > 0) {
  //     //       return args.value + '\n' + args.dataset.label;
  //     //     }

  //     //   }


  //     //   // return object if it is image
  //     //   // return { src: 'image.png', width: 16, height: 16 };
  //     // }
  //   },
  //     // {
  //     //   render: 'value',
  //     //   fontFamily: 'iransans',
  //     //   fontColor: '#000',
  //     //   textMargin: -17,
  //     //   // fontColor: function (args) {
  //     //   //   return '#fff';
  //     //   // },
  //     //   //   render: function (args) {
  //     //   //     // args will be something like:
  //     //   //     // { label: 'Label', value: 123, percentage: 50, index: 0, dataset: {...} }

  //     //   //     if (args.dataset.label == 'فروخته شده') {
  //     //   //       if (args.value > 0) {
  //     //   //         return (args.value);
  //     //   //       }
  //     //   //     }


  //     //   //     // return object if it is image
  //     //   //     // return { src: 'image.png', width: 16, height: 16 };
  //     //   //   }
  //     // }
  //   ],
  // }
};

export const HdfChart = (props) => {

  const [data, setData] = useState(props.data);

  useEffect(() => {
    setData(props.data)
  })

  return (
    <div className="dashboard-box bar-chart-box bar-chart-container">
      {
        props.loading ?
          <div className="loader-container">
            <div class="loader-02"></div>
          </div>
          :
          data &&
          <React.Fragment>
            <span class="title pull-right">نمودار میزان تولید ورق پرس شده</span>
            <Bar
              data={{
                labels: data.map(el => (el.label)),
                datasets: [
                  // {
                  //   label: "پارکت",
                  //   backgroundColor: '#3366CC',
                  //   // borderColor: '#001D4F',
                  //   // borderWidth: 1,
                  //   // hoverBackgroundColor: '#4567C6',
                  //   // hoverBorderColor: '#001D4F',
                  //   data: data.map(el => el.productCount.toFixed(0)),
                  //   xAxisID: "bar-x-axis1",
                  // },
                  // {
                  //   label: "پارکت درجه 2",
                  //   backgroundColor: '#10ec1f',
                  //   // borderColor: '#007233',
                  //   // borderWidth: 1,
                  //   // hoverBackgroundColor: '#56D556',
                  //   // hoverBorderColor: '#007233',
                  //   data: data.map(el => el.gradeTwoProductCount.toFixed(0)),
                  //   xAxisID: "bar-x-axis1",
                  // },
                  // {
                  //   label: "ضایعات تایل",
                  //   backgroundColor: '#DC3912',
                  //   // borderColor: '#BA121A',
                  //   // borderWidth: 1,
                  //   // hoverBackgroundColor: '#DD5900',
                  //   // hoverBorderColor: '#BA121A',
                  //   data: data.map(el => el.tileWasteCount.toFixed(0)),
                  //   xAxisID: "bar-x-axis1",
                  // },
                  {
                    label: "ورق پرس شده",
                    backgroundColor: '#FF9800',
                    // borderColor: '#BA121A',
                    // borderWidth: 1,
                    // hoverBackgroundColor: '#DD5900',
                    // hoverBorderColor: '#BA121A',
                    data: data.map(el => el.hdfCount.toFixed(0)),
                    xAxisID: "bar-x-axis1",
                  },
                  {
                    label: "ضایعات ورق پرس شده",
                    backgroundColor: '#10ec1f',
                    // borderColor: '#BA121A',
                    // borderWidth: 1,
                    // hoverBackgroundColor: '#DD5900',
                    // hoverBorderColor: '#BA121A',
                    data: data.map(el => el.hdfWasteCount.toFixed(0)),
                    xAxisID: "bar-x-axis1",
                  },
                ]
              }}
              options={options}
            />
          </React.Fragment>
      }
    </div>
  )
}
